module.exports = __webpack_public_path__ + "static/img/sy_banner_bg.2644283.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/sy_banner_bg.png
// module id = zHLO
// module chunks = 1